import { z } from 'zod'

export const CriterionByTargetingTag = z.record(z.object({ criterion: z.number(), reason: z.string() }))
export type CriterionByTargetingTag = z.infer<typeof CriterionByTargetingTag>
